import React, { FC } from 'react';
import { Container, Row } from 'react-bootstrap';
import { ClDrawerLeft, ClDrawerRight } from 'components/clientComp/clDrawer';
import ClHeader from 'components/clientComp/clHeader';
import ClBanner from 'components/clientComp/clBanner';
import ClAbout from 'components/clientComp/clAbout';
import ClExperience from 'components/clientComp/clExperience';
import ClPortfolio from 'components/clientComp/clPortfolio';
import ClContact from 'components/clientComp/clContact';
import ClFooter from 'components/clientComp/clFooter';

import './clHomepage.scss';

const ClHomepage: FC = () => {
  return (
    <Container fluid className="cl-homepage">
      <ClHeader />
      <div className="cl-homepage-container">
        <div className="cl-homepage-left__side">
          <ClDrawerLeft />
        </div>
        <Container className="cl-homepage-main">
          <Row id="home">
            <ClBanner />
          </Row>
          <Row id="about">
            <ClAbout />
          </Row>
          <Row id="experience">
            <ClExperience />
          </Row>
          <Row id="portfolio">
            <ClPortfolio />
          </Row>
          <Row id="contact">
            <ClContact />
          </Row>
          <Row>
            <ClFooter />
          </Row>
        </Container>
        <div className="cl-homepage-right__side">
          <ClDrawerRight />
        </div>
      </div>
    </Container>
  );
};

export default ClHomepage;
